import { useQuery } from '@tanstack/react-query'
import { baseURL } from '@/v2/constants/requests'

export const useGetUsers = query => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['Users', query || ''],
    queryFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/users.json?query=${query}`)
      if (!res.ok) {
        throw new Error("We couldn't find any users")
      }
      const result = await res.json()
      return result
    },
  })

  return { users: data, isLoading, isError }
}
